import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CommonSliderImagesListItem
  from 'components/dashboard/image-slider/common-slider/CommonSliderImagesListItem';

import './CommonSliderImagesList.css';


function CommonSliderImagesList(props) {
  const { item } = props;
  const { t } = useTranslation();

  return (
    <div className="common-slider-images-list__component">
      {item.media_items && item.media_items.length > 0 &&
        <div className="images-count">
          {t('Images')} ({item.media_items.length})
        </div>
      }

      {item.media_items && item.media_items.map(image => (
        <CommonSliderImagesListItem
          key={`common-slider-images-list-item-${item.id}=${image.id}`}
          image={image}
        />
      ))}
    </div>
  );
}

CommonSliderImagesList.propTypes = {
  item: PropTypes.object.isRequired,
};

export default CommonSliderImagesList;
